export default __webpack_public_path__ + "static/media/mb9.9fb61831.JPG";